<template>
  <el-dialog title="驳回修改" :visible.sync="dialogFormVisible" width="40%">
    <el-form :model="form" :label-position="labelPosition" label-width="80px">
      <el-form-item label="请输入修改意见">
        <el-input
          v-model="form.remark"
          autocomplete="off"
          type="textarea"
          :maxLength="200"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="handleRejectModification()"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { approveEngineer } from "@/api/masterFile";
export default {
  components: {},
  data() {
    return {
      dialogFormVisible: false,
      labelPosition: "top",
      form: {
        remark: "",
        id: "",
        status: 2
      }
    };
  },
  created() {},
  methods: {
    openDialog(id) {
      this.form.id = id;
      this.dialogFormVisible = true;
    },
    //驳回修改
    async handleRejectModification() {
      let { statusCode, message } = await approveEngineer(this.form);
      if (statusCode === 200) {
        this.$message.success("操作成功");
        this.$emit("opera-success");
        this.dialogFormVisible = false;
      } else {
        this.$message.error(message);
      }
    },
    closeDialog() {
      this.dialogFormVisible = false;
    }
  }
};
</script>
<style scoped lang="scss">
.dialog-footer {
  padding: 20px;
}

.excelBtn {
  padding: 10px 0;
  display: flex;
  align-items: center;
}
.btnclass {
  display: flex;
  align-items: center;
  img {
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/system/components/MasterReject.vue